import { openBlock as t, createElementBlock as n, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return t(), n("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M3 5h8v6H3zm0 8h8v6H3zm10-8h8v6h-8zm0 8h8v6h-8z"
    }, null, -1)
  ])]);
}
const m = { render: l };
export {
  m as default,
  l as render
};
